<template>
  <v-app>
    <Redirection v-if='!loggedIn' />

    <VideoPlayer />

    <template v-if="loggedIn">
      <AppHeader
        :htmlContent="getCGUHtml"
        :cguAccepted="cguAccepted && CGULoaded"
      />
      <v-main class='primary'>
        <CGUDialog
          v-if="!isExecutiveReport && (loggedIn && !cguAccepted)"
          :htmlContent="getCGUHtml"
          :isActive="!cguAccepted"
        />
        <router-view v-if="loggedIn && cguAccepted && CGULoaded" />
      </v-main>

      <Stepper v-if="showStepper" />
    </template>
  </v-app>
</template>

<script lang='ts'>
import { Component, Vue, Watch } from 'vue-property-decorator';
import Stepper from '@/components/Stepper.vue';
import Redirection from '@/components/Redirection.vue';
import AppHeader from '@/components/AppHeader.vue';
import ScenarioProjectHeader from '@/components/ScenarioProjectHeader.vue';
import CGUDialog from '@/components/CGU/CGUDialog.vue';
import VideoPlayer from '@/components/VideoPlayer.vue';

@Component({
  components: {
    AppHeader,
    Stepper,
    Redirection,
    ScenarioProjectHeader,
    CGUDialog,
    VideoPlayer
  }
})
export default class App extends Vue {
  private showStepper: boolean = false;

  get cguAccepted(): boolean {
    return this.$store.getters['cgu/getCGUAcceptance'];
  }
  get CGULoaded(): boolean {
    return this.$store.getters['cgu/getCGUAreLoaded'];
  }
  get getCGUHtml(): any {
    return this.$store.getters['cgu/getCGUHtml'];
  }
  get getCGUContent(): any {
    return this.$store.getters['cgu/getCGU'];
  }
  get getLocale(): string {
    return this.$i18n.locale;
  }

  get isExecutiveReport(): boolean {
    return this.$route
      ?.name
      ?.includes('scenario_executive_report') === true;
  }

  get loggedIn(): boolean {
    return this.$store.getters['user/username'] !== undefined;
  }

  private created(): void {
    this.$store.dispatch('user/loadUser');
    this.$store.dispatch('cgu/getLatestCguFromApi');
    this.$store.dispatch('structure/loadRules');
    this.initLanguage();
  }

  private initLanguage(): void {
    const current = localStorage.getItem('lang');
    if (!current || !['en', 'fr'].includes(current)) {
      const browserLanguages = navigator.languages;
      const defaultLocale = browserLanguages.find(lang => lang.slice(0, 2) === 'en' || lang.slice(0, 2) === 'fr');
      this.$i18n.locale = defaultLocale ? defaultLocale.substring(0, 2) : 'en';
    }
  }

  @Watch('getLocale')
  private onLocalChange(value: string): void {
    localStorage.setItem('lang', value);
    if (this.cguAccepted) {
      return;
    }
    this.$store.dispatch('cgu/getCguPage', this.getCGUContent.content[value]);
  }

  @Watch('$route', { immediate: true })
  private onRouteChange(): void {
    this.showStepper =
      (this.$route &&
        this.$route.name &&
        this.$route.name.includes('scenario_')) ||
      false;
    window.scrollTo(0, 0);
    this.$store.dispatch('stepper/setNextRoute', this.$route);
  }
}
</script>

<style lang="stylus">
// @import url('https://fonts.googleapis.com/css?family=Big+Shoulders+Text|Roboto&display=swap');
body {
  // font-size 14px;
}
#app > div.v-dialog__content.v-dialog__content--active > div {
  overflow:  !important;
}
#app {
  @font-face {
    font-family: 'icomoon';
    src: url('../ux/glyphfont/fonts/icomoon.eot');
    src: url('../ux/glyphfont/fonts/icomoon.eot?#iefix') format('embedded-opentype'), url('../ux/glyphfont/fonts/icomoon.ttf') format('truetype'), url('../ux/glyphfont/fonts/icomoon.woff') format('woff'), url('../ux/glyphfont/fonts/icomoon.svg') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  .center-text-input input {
    text-align: center;
  }

  .center-text-label label {
    text-align: center;
  }

  .first-letter-capital:first-letter {
    text-transform: capitalize;
  }

  .center-select {
    .v-select__selection {
      width: 100%;
      text-align: center;
    }
    .v-select__selection--comma {
      margin 0px;
      overflow visible;
    }

    .v-list-item__title {
      width: 100%;
      text-align: center;
      justify-content: center;
    }
  }
}
</style>
